export const MIN_VOTE_COUNT = 10;
